import React from "react";

import IconStyles, { IconStyle } from "../../types/enums/IconStyles";
import ButtonThemes, { ButtonTheme } from "../../types/enums/ButtonThemes";

import "./ToolbarButton.scss";
import ReactTooltip from "react-tooltip";

interface ToolbarButtonProps {
    text?: string,
    icon?: string,
    iconStyle?: IconStyle,
    visible?: boolean,
    disabled?: boolean,
    theme?: ButtonTheme,
    tooltip?: string,
    tooltipPlace?: string,
    className?: string,
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

class ToolbarButton extends React.Component<ToolbarButtonProps> {
    componentDidMount(): void {
        ReactTooltip.rebuild();
    }

    render(): React.ReactNode {

        let classTheme = "normal-button";

        switch (this.props.theme) {
            case ButtonThemes.OK:
                classTheme = "ok-button";
                break;
        }

        let iconStyle = 
            this.props.iconStyle ?? 
            IconStyles.Normal;

        return (
        !this.props ?
        null :
        (this.props.visible ?? true) ?
        <button className={`toolbar-button ${classTheme} ${this.props.className ?? ""}`}
                disabled={this.props.disabled ?? false}
                data-tip={this.props.tooltip}
                data-place={this.props.tooltipPlace}
                onClick={this.props.onClick}>
            {this.props.icon &&
            <i className={iconStyle}>{this.props.icon}</i>}
            {(this.props.text ||
            !this.props.icon) &&
            <span>{this.props.text ?? "Button"}</span>}
        </button> :
        null
        );
        
    }
    
}

export default ToolbarButton;